import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LicenseGroup, Product } from '@queries/generated';
import { EcommerceTrackingService } from '@services/ecommerce-tracking.service';
import { ShoppingCartService } from '@services/shopping-cart.service';
import { getProductIdFromPath } from '@util/string';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'vnm-add-to-cart',
  templateUrl: './add-to-cart.component.html',
  styleUrls: ['./add-to-cart.component.scss']
})
export class AddToCartComponent implements OnChanges {
  @Input() license?: LicenseGroup;
  @Input() product?: Product;
  @Input() productId!: number;
  @Input() quantity = 1;

  @Input() label = 'add-to-cart.label';
  @Input() icon = 'cart-plus';
  @Input() iconOnly = false;

  faIcon = `fa fa-fw fa-${this.icon}`;
  _label = 'add-to-cart.label';

  constructor(
    private shoppingCartService: ShoppingCartService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private ecom: EcommerceTrackingService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.license) {
      this.productId = getProductIdFromPath(this.license?.course.paths.productUrl);
    }

    if (changes.product) {
      this.productId = this.product?.id;
    }

    if (changes.label) {
      this._label = this.label;
    }

    if (changes.icon) {
      this.faIcon = `fa fa-fw fa-${this.icon}`;
    }

    if (changes.iconOnly) {
      this._label = this.iconOnly ? '' : this.label;
    }
  }

  onAddToCart() {
    const { productId, quantity } = this;
    const cartItem = { productId, quantity };

    this.shoppingCartService.addToCart({ cartItem }).subscribe(
      ({ cartItems }) => {
        const cartItem = cartItems.find((item) => item.product.id === productId);
        const {
          quantity,
          product: { name }
        } = cartItem;

        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('product-catalog.product-added', { name, quantity })
        });

        this.ecom.addToCart(cartItem);
      },
      (errors) => {
        errors?.forEach((error) => {
          this.messageService.add({
            severity: 'error',
            summary: error.message
          });
        });
      }
    );

    this.quantity = 1;
  }
}
